import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const MonitorIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21 2L3 2C1.9 2 1 2.9 1 4L1 16C1 17.1 1.9 18 3 18L10 18L10 20L8 20L8 22L16 22L16 20L14 20L14 18L21 18C22.1 18 23 17.1 23 16L23 4C23 2.9 22.1 2 21 2ZM21 16L3 16L3 4L21 4L21 16Z"
      fill="currentColor"
    />
  </svg>
);

MonitorIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(MonitorIcon);
